module.exports = __webpack_public_path__ + "img/David.8a7a6c69.png";